// extracted by mini-css-extract-plugin
module.exports = {"DedicatedCustomer":"DedicatedCustomer_DedicatedCustomer__FUvQ4","slideIn":"DedicatedCustomer_slideIn__TO_2O"};